export const ENVIRONMENT = {
    // API_URL: "http://103.36.103.151/property-index-back-end/",
    // FILE_URL: "http://103.36.103.151/property-index-back-end/public/uploads/",
    // API_URL: "http://localhost/property-index-back-end-main/",
    // FILE_URL: "http://localhost/property-index-back-end-main/public/uploads/",
    API_URL: "https://propertyindexbd.com/property-index-back-end/",
    FILE_URL: "https://propertyindexbd.com/property-index-back-end/public/uploads/"
}
